import Divider from "@mui/material/Divider";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { styled } from "@mui/material/styles";
import { useAppAssistenteIA } from "../hooks/useAppAssistenteIA";
import AppAssistenteIAHeader from "./AppAssistenteIAHeader";
import AppAssistenteIAMensagens from "./AppAssistenteIAMensagens";
import MessageComposer from "./MessageComposer";

const StyledSwipeableDrawer = styled(SwipeableDrawer, {
	shouldForwardProp: (prop) => prop !== "expandido",
})<{ expandido?: boolean }>(({ theme, expandido }) => ({
	"& .MuiDrawer-paper": {
		width: expandido ? "100vw" : "min(600px, 100vw)",
		maxWidth: "100vw",
		height: "100vh",
		overflow: "hidden",
		borderTopLeftRadius: expandido ? 0 : 18,
		borderBottomLeftRadius: expandido ? 0 : 18,
		background: theme.vars.palette.background.paper,
		color: theme.vars.palette.text.primary,
	},
}));

export default function AppAssistenteIADrawer({ ativo }: Readonly<{ ativo: boolean }>) {
	const {
		contexto,
		mensagens,
		aberto: painelAberto,
		expandido,
		enviando,
		limpando,
		erro,
		manterContexto,
		fechar: onClose,
		abrir: onOpen,
		alternarExpandido: onToggleExpandido,
		definirManterContexto: onAlterarManterContexto,
		enviarMensagem: onEnviarMensagem,
		limparConversa: onLimparConversa,
	} = useAppAssistenteIA();
	const aberto = painelAberto && ativo;

	if (!contexto) return null;

	return (
		<StyledSwipeableDrawer
			open={aberto}
			anchor="right"
			onOpen={onOpen}
			onClose={onClose}
			disableSwipeToOpen
			expandido={expandido}
		>
			<div className="flex h-full min-h-0 flex-col overflow-hidden">
				<AppAssistenteIAHeader
					pendente={enviando || limpando}
					expandido={expandido}
					onToggleExpandido={onToggleExpandido}
					onClose={onClose}
					onLimparConversa={onLimparConversa}
				/>

				<AppAssistenteIAMensagens
					aberto={aberto}
					expandido={expandido}
					contexto={contexto}
					mensagens={mensagens}
					enviando={enviando}
					limpando={limpando}
					onEnviarMensagem={onEnviarMensagem}
				/>

				<Divider />

				<MessageComposer
					aberto={aberto}
					enviando={enviando}
					limpando={limpando}
					erro={erro}
					manterContexto={manterContexto}
					onAlterarManterContexto={onAlterarManterContexto}
					onEnviarMensagem={onEnviarMensagem}
				/>
			</div>
		</StyledSwipeableDrawer>
	);
}
